import Vue from 'vue'
import Router from 'vue-router'
import allRoutes from './routes'
import auth from '@/scripts/auth'

Vue.use(Router)

// 修复重复点击报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return originalPush.call(this, to).catch(() => {})
}

const router = new Router({
  mode: 'history',
  routes: allRoutes,
})

router.beforeEach(async (to, from, next) => {
  try {
    if (to.path === '/login') {
      return next()
    }

    const urlParams = new URLSearchParams(window.location.search)
    const hasAccessKey = urlParams.get('accessKey') || urlParams.get('user')

    let token = auth.getLocalStorageToken()
    if (!token || hasAccessKey) {
      token = await auth.getToken()
    }
    if (!token) {
      console.warn('未找到token，跳转到登录页')
      return next('/login')
    }
    next()
  } catch (error) {
    console.error('获取token失败:', error)
    next('/login')
  }
})

export default router
